export default __webpack_public_path__ + "a026a71144257dadcecf1c652ad87835.png";